import { render, staticRenderFns } from "./limit-row.vue?vue&type=template&id=3ce351a8&"
import script from "./limit-row.vue?vue&type=script&lang=js&"
export * from "./limit-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports